module.exports = __webpack_public_path__ + "static/blue-square-e48fd93352d18548e0ef56721c4b151b.png";